/* global BootStrapC2C, NuanMessaging */
import { NUANCE_TIMEOUT } from "src/app/constants";

export default async function initialiseNuance(
  nuanceDataCenter,
  nuanceTagServerName,
  nuanceVendorUUID,
  nuanceData,
  onStatusChange
) {
  let timeout;

  try {
    return await new Promise((resolve, reject) => {
      timeout = setTimeout(() => {
        reject(new Error("Nuance Timeout"));
      }, NUANCE_TIMEOUT);

      const c2c = new BootStrapC2C({
        accessibilityMessages: {
          end: "End Chat",
          resume: "Resume Chat",
          start: "Start Chat",
        },
      });

      NuanMessaging.initializeMessagingSDK(
        nuanceDataCenter,
        nuanceTagServerName,
        nuanceVendorUUID,
        () => {
          NuanMessaging.getAndSetSDKConfig().siteID = 10007081;

          NuanMessaging.getAndSetSDKConfig().registerForMessagingEvents(
            "onC2CStateChanged",
            (event) => {
              const { newState } = event;

              clearTimeout(timeout);
              onStatusChange(newState);
              resolve(true);
            }
          );

          NuanMessaging.getAndSetSDKConfig().enableC2CPluginForMinimizedState(
            c2c
          );
          NuanMessaging.getAndSetSDKConfig().isEmbedded = true;
          NuanMessaging.getAndSetSDKConfig().setPageData(
            "bootstrap1PCSolution",
            true
          );
          NuanMessaging.getAndSetSDKConfig().setPageData(
            "nuanceData",
            nuanceData
          );
          NuanMessaging.loadChatAssets(true);
        }
      );
    });
  } finally {
    clearTimeout(timeout);
  }
}
